import { createContext, useContext } from "react";
import { initialConfig } from "./constants";
export var NavContext = createContext(initialConfig);
export function useEnvironment() {
    var environment = useContext(NavContext).environment;
    return environment;
}
export function useHasFetchedConfig() {
    var hasFetchedConfig = useContext(NavContext).hasFetchedConfig;
    return hasFetchedConfig;
}
export function useConfig() {
    var config = useContext(NavContext).config;
    return config;
}
export function useHeaderConfig() {
    var config = useConfig();
    return config.header;
}
export function useFooterConfig() {
    var config = useConfig();
    return config.footer;
}
export function useLiveChatConfig() {
    var config = useConfig();
    return config.liveChat;
}
export function useEntryModalConfig() {
    var config = useConfig();
    return config.entryModal;
}
export function useEndpoints() {
    var endpoints = useContext(NavContext).endpoints;
    return endpoints;
}
